import { Component, Input, OnInit } from '@angular/core';
import {
    BookingType,
    PriceInBookingType, TravellerXRefType,
} from "@afidium/ts-facade";
import { wenji } from "libraries/interfaces/IWenji";
import { SectorInBookingType } from "@afidium/ts-facade/model/sectorInBookingType";
import { ECostOrRetail } from "../../booking-price-card.enum";
import { Yii } from "libraries/interfaces/Yii";
import { DifferenceType } from "@afidium/ts-facade/model/differenceType";
import {ICancelAndExchange, PricesTableService} from '../../services/prices-table.service';
import { ISectorDetail, ISectorDifferences, ISectorMaxDetail, ISectorSeatAndDates } from "libraries/interfaces/fare-optimisation/ISector";
import {PriceDetailInBookingType} from "@afidium/ts-facade/model/priceDetailInBookingType";


export class Wording {
    public readonly ff: string = Yii.t('wui-shared-js', 'FF : ');
    public readonly fb: string = Yii.t('wui-shared-js', 'FB : ');
    public beforeDeparture: string = Yii.t('wui-shared-js', 'Av Dép.: ');
    public afterDeparture: string = Yii.t('wui-shared-js', 'Ap Dép.: ');
    public cancellation: string = Yii.t('wui-shared-js', 'Annulable : ');
    public exchange: string = Yii.t('wui-shared-js', 'Échangeable : ');
}

@Component({
    selector: 'sector-detail',
    template: `
        <div *ngFor="let dataItem of dataToDisplay">
            <table>
                <tr>
                    <td class="fixed" *ngIf="!showDifferencesOnly">
                        <display-difference [difference]="dataItem.beginDateDifference"
                                            [dateFormat]="dateFormat"
                                            [isBold]="false"></display-difference>
                        <div class="sameLine">
                            <sector-header
                                    [sectors]="[dataItem.sector]"
                                    [rateType]="price[costOrRetail].xId"
                                    [showBeginEndTime]="true">
                            </sector-header>
                        </div>
                        <div>
                            <display-difference
                                    [difference]="dataItem.seatCodeDifference"
                                    [isBold]="false"></display-difference>&nbsp;<span>{{ dataItem.carrierName }}</span>
                        </div>
                    </td>
                    <ng-container *ngIf="showMoreDetails || showDifferencesOnly">
                        <td class="fixed">
                            <div *ngIf="dataItem.cancellable && dataItem.exchangeable && !showDifferencesOnly">
                                <display-difference [difference]="dataItem.cancellableDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="false"></display-difference>
                                <display-difference [difference]="dataItem.exchangeableDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="false"></display-difference>
                            </div>
                            <div *ngIf="dataItem.ff">
                                {{wording.ff}}
                                <display-difference [difference]="dataItem.fareFamilyDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="!showMoreDetails"></display-difference>
                            </div>
                            <div *ngIf="dataItem.fb">
                                {{wording.fb}}
                                <display-difference [difference]="dataItem.fareBasisDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="!showMoreDetails"></display-difference>
                            </div>
                            <div *ngIf=" dataItem.cancellationBeforeDepartureDifference && showDifferencesOnly">
                                {{wording.cancellation}}
                                <br>
                                {{wording.beforeDeparture}}
                                <display-difference [difference]="dataItem.cancellationBeforeDepartureDifference"
                                                    [showOtherValue]="false"
                                                    [showInnerHtml]="true"></display-difference>
                            </div>
                            <div *ngIf=" dataItem.cancellationAfterDepartureDifference && showDifferencesOnly">
                                <!--                                {{wording.cancellation}}-->
                                <!--                                <br>-->
                                {{wording.afterDeparture}}
                                <display-difference [difference]="dataItem.cancellationAfterDepartureDifference"
                                                    [showOtherValue]="false"
                                                    [showInnerHtml]="true"></display-difference>
                            </div>
                            <div *ngIf=" dataItem.exchangeBeforeDepartureDifference && showDifferencesOnly">
                                {{wording.exchange}}
                                <br>
                                {{wording.beforeDeparture}}
                                <display-difference [difference]="dataItem.exchangeBeforeDepartureDifference"
                                                    [showOtherValue]="false"
                                                    [showInnerHtml]="true"></display-difference>
                            </div>
                            <div *ngIf=" dataItem.exchangeAfterDepartureDifference && showDifferencesOnly">
                                {{wording.afterDeparture}}
                                <display-difference [difference]="dataItem.exchangeAfterDepartureDifference"
                                                    [showOtherValue]="false"
                                                    [showInnerHtml]="true"></display-difference>
                            </div>
                            <div *ngIf="dataItem.luggageQuantity || dataItem.luggageWeight">
                                <display-difference [difference]="dataItem.luggageQuantityDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="!showMoreDetails"></display-difference>
                                <ng-container *ngIf="dataItem.luggageQuantity && dataItem.luggageWeight">
                                    &nbsp;-&nbsp;
                                </ng-container>
                                <display-difference [difference]="dataItem.luggageWeightDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="!showMoreDetails"></display-difference>
                                <display-difference [difference]="dataItem.luggageUnitDifference"
                                                    [showOtherValue]="false"
                                                    [isBold]="!showMoreDetails"></display-difference>
                            </div>
                        </td>
                    </ng-container>
                </tr>
            </table>
        </div>
    `,
    styles: [`

        .fixed {
            width: 50%;
            vertical-align: top;
        }

        .sameLine {
            display: flex;
            flex-direction: row;
        }

        table, tr, td {
            margin: 0;
            border: none !important;
            border-collapse: unset !important;
        }

        tr {
            background: none !important;
        }

    `]
})
export class SectorDetailComponent implements OnInit {

    @Input()
    public booking: BookingType;

    @Input()
    public price: PriceInBookingType;

    @Input()
    public costOrRetail: string = ECostOrRetail.cost;

    @Input()
    public showMoreDetails: boolean = true;

    @Input()
    public showDifferencesOnly: boolean = false;

    @Input()
    public differences: DifferenceType[];

    @Input()
    public typoPax?: string;

    @Input()
    public sectorSignature?: string;

    @Input()
    public isOriginOptimisation: boolean = false;

    @Input()
    public tarificationPrice?: PriceInBookingType;

    public readonly dateFormat: string = JSON.parse(wenji.ui.dateFormat).short;
    public readonly timeFormat: string = JSON.parse(wenji.ui.dateFormat).time;

    public sectors: SectorInBookingType[];
    public dataToDisplay: ISectorMaxDetail[] = [];
    public wording: Wording = new Wording();

    public constructor(
        private readonly pricesTableService: PricesTableService
    ) {
    }

    public ngOnInit(): void {
        if (this.sectorSignature) {
            this.sectors = this.booking?.sectorArray.filter((sector: SectorInBookingType): boolean => sector.signatureArray[0] === this.sectorSignature);
        } else {
            this.sectors = this.pricesTableService.getSectorsBySignature(this.price, this.booking, this.costOrRetail);
        }
        if(!this.typoPax && this.price[this.costOrRetail]?.detailArray?.length){
            const detailFound : PriceDetailInBookingType = this.price[this.costOrRetail].detailArray
                .find((detail: PriceDetailInBookingType): boolean => !!detail.travellerArray?.length);
            if(detailFound){
                this.typoPax = detailFound.travellerArray[0].xType;
            }
        }
        (this.sectors || []).forEach((sector: SectorInBookingType): void => {
            const sectorDetail: ISectorDetail = this.pricesTableService.constructSectorDetail(
                this.price,
                this.costOrRetail,
                sector,
                this.differences,
                this.typoPax
            );
            const sectorMaxDetail: ISectorMaxDetail = {
                sector,
                carrierName: this.getCarrier(sector?.signatureArray?.[0]),
                differenceBeginEndDays: this.getNumberOfDaysBetweenDepartureAndArrival(sector?.signatureArray?.[0]),
                ...sectorDetail,
            };

            const sectionSeatAndDates: ISectorSeatAndDates = {
                seatCode: sector?.seat?.code,
                beginDate: this.getBeginDate(sector?.signatureArray?.[0]),
                endDate: this.getEndDate(sector?.signatureArray?.[0]),
            };

            const sectorRoutingDifferences: ISectorDifferences = this.pricesTableService.formatSectorRoutingDifferences(
                this.differences,
                sectionSeatAndDates, sector
            );
            if(this.tarificationPrice){
                this.handleCancelAndExchangeDiff(sectorMaxDetail);
            }
            this.dataToDisplay.push({
                ...sectorMaxDetail,
                ...sectorRoutingDifferences
            });
        });
    }

    private handleCancelAndExchangeDiff(sectorMaxDetail: ISectorMaxDetail): void {
        const tarificationCancelAndExchange: ICancelAndExchange = this.pricesTableService.checkCancelAndExchangeDifferences(this.tarificationPrice[this.costOrRetail].detailArray);
        const optimisationCancelAndExchange: ICancelAndExchange = this.pricesTableService.checkCancelAndExchangeDifferences(this.price[this.costOrRetail].detailArray);
        if(tarificationCancelAndExchange.exchangeable !== optimisationCancelAndExchange.exchangeable){
            sectorMaxDetail.exchangeableDifference = {
                actualValue: optimisationCancelAndExchange.exchangeable ? "Ech." : "Non Ech.",
                otherValue: tarificationCancelAndExchange.exchangeable ? "Ech." : "Non Ech.",
                impact: "Change"
            };
        }

        if(tarificationCancelAndExchange.cancellable !== optimisationCancelAndExchange.cancellable){
            sectorMaxDetail.cancellableDifference = {
                actualValue: optimisationCancelAndExchange.cancellable ? "Ann." : "Non Ann.",
                otherValue: tarificationCancelAndExchange.cancellable ? "Ann." : "Non Ann.",
                impact: "Change"
            };
        }
    }

    public getBeginDate(sectorSignature: string): string {
        return this.booking.sectorArray?.find((sectorItem: SectorInBookingType): boolean => sectorItem.signatureArray?.[0] === sectorSignature)?.begin?.value;
    }

    public getEndDate(sectorSignature: string): string {
        return this.booking.sectorArray?.find((sectorItem: SectorInBookingType): boolean => sectorItem.signatureArray?.[0] === sectorSignature)?.end?.value;
    }

    public getCarrier(sectorSignature: string): string {
        return this.booking.sectorArray?.find((sectorItem: SectorInBookingType): boolean => sectorItem.signatureArray?.[0] === sectorSignature)?.carrier?.iata;
    }

    public getNumberOfDaysBetweenDepartureAndArrival(sectorSignature: string): string {
        const sectorItem: SectorInBookingType = this.booking.sectorArray.find((sector: SectorInBookingType) => sector.signatureArray?.[0] === sectorSignature);
        const departureDate: Date = new Date(sectorItem.begin.value);
        const arrivalDate: Date = new Date(sectorItem.end.value);
        const xMoment: string = sectorItem.end.xMoment;

        if (xMoment === "NextDay") {
            const timeDifference: number = arrivalDate.getTime() - departureDate.getTime();
            const daysDifference: number = Math.ceil(timeDifference / (1000 * 3600 * 24));
            return `+(${daysDifference}J)`;
        } else if (xMoment === "SameDay") {
            return "";
        }
    }
}
